import { render, staticRenderFns } from "./AgencyLogo.vue?vue&type=template&id=4baf6b25&"
import script from "./AgencyLogo.vue?vue&type=script&lang=ts&"
export * from "./AgencyLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QTable,QItem,QItemSection,QItemLabel}, component.options.components || {})
